import request from '@/utils/request'
// 发送验证码
export function verify_code(data) {
    return request({
        url: '/api/tools/check_code',
        method: 'post',
        params: data
    })
}
// 注册验证
export function Register_verify(data) {
    return request({
        url: '/api/v2/Register/verify',
        method: 'post',
        params: data
    })
}
// 注册第一步
export function register_verify(data) {
    return request({
        url: '/api/v2/register/verify',
        method: 'post',
        params: data
    })
}
// 注册完成
export function complete(data) {
    return request({
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        url: '/api/v2/register/complete',
        method: 'post',
        data: data
    })
}
// 测试接口
export function avatar(data) {
    return request({
        url: '/api/v2/register/avatar',
        method: 'post',
        data: data
    })
}
// 更换手机号
export function mobile(data) {
    return request({
        url: '/api/mobile/index',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/register.js